__turbopack_context__.v({
  "border": "BrowseContainer-module-scss-module__yGYszG__border",
  "horizontalGutters": "BrowseContainer-module-scss-module__yGYszG__horizontalGutters",
  "largeMaxWidth": "BrowseContainer-module-scss-module__yGYszG__largeMaxWidth",
  "root": "BrowseContainer-module-scss-module__yGYszG__root",
});
